import { mergeTranslations } from "ra-core";
import polyglotI18nProvider from "ra-i18n-polyglot";
import englishMessages from "ra-language-english";
import { raSupabaseEnglishMessages } from "ra-supabase-language-english";
import { englishCrmMessages } from "./englishCrmMessages";
import { ukrainianCrmMessages } from "./ukrainianCrmMessages";
import { ukrainianRaMessages } from "./ukrainianRaMessages";

const raSupabaseEnglishMessagesOverride = {
  "ra-supabase": {
    auth: {
      password_reset: "Check your emails for a Reset Password message.",
    },
    oauth: {
      authorize: "Authorize Application",
      authorize_details: "This application wants to access your account.",
      access_scope:
        "It will be able to read and modify your data, with the same permissions as your account.",
      approved: "Authorization Approved",
      close_tab: "You can now close this tab.",
      no_request: "No authorization request found",
    },
  },
};

const englishCatalog = mergeTranslations(
  englishMessages,
  raSupabaseEnglishMessages,
  raSupabaseEnglishMessagesOverride,
  englishCrmMessages,
);

// English stays underneath as a fallback for any key added upstream later.
const ukrainianCatalog = mergeTranslations(
  englishCatalog,
  ukrainianRaMessages,
  ukrainianCrmMessages,
);

export const defaultLocale = "uk";

export const i18nProvider = polyglotI18nProvider(
  (locale) => (locale === "en" ? englishCatalog : ukrainianCatalog),
  defaultLocale,
  [
    { locale: "uk", name: "Українська" },
    { locale: "en", name: "English" },
  ],
  { allowMissing: true },
);

export const testI18nProvider = polyglotI18nProvider(
  () => englishCatalog,
  "en",
  [{ locale: "en", name: "English" }],
  { allowMissing: true },
);
